// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import VehicleService from '@services/vehicle'

export const getAllOSTChangeRequest = createAsyncThunk('ownership-transfer/getAllOSTChangeRequest', async (params, { rejectWithValue }) => {
  try {
    const response = await VehicleService.getAllOSTChangeRequest(params)
    // console.log('cc', response.data)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const addOstChangeRequest = createAsyncThunk('ownership-transfer/addOstChangeRequest', async (request, { rejectWithValue }) => {
  try {
    const response = await VehicleService.addOstChangeRequest(request)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getOstChangeRequestById = createAsyncThunk('ownership-transfer/getOstChangeRequestById', async (id, { rejectWithValue }) => {
  try {
    const response = await VehicleService.getOstChangeRequestById(id)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getOstChangeRequestsByVehicleId = createAsyncThunk('ownership-transfer/getOstChangeRequestsByVehicle', async (vehicleId, { rejectWithValue }) => {
  try {
    const response = await VehicleService.getOstChangeRequestsByVehicle(vehicleId)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})
  
export const updateOstChangeRequest = createAsyncThunk('ownership-transfer/updateOstChangeRequest', async (request, { rejectWithValue }) => {
  try {
    const response = await VehicleService.updateOstChangeRequest(request)
    // dispatch(getAllVehicleOwnershipTransfer(getState()?.vehicleOwnershipTransfers.params))
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const deleteOstChangeRequest = createAsyncThunk('cancellation-types/deleteOstChangeRequest', async (id, { dispatch, getState }) => {
  await VehicleService.deleteOstChangeRequest(id)
  await dispatch(getAllOSTChangeRequest(getState()?.vehicleOwnershipTransfers.params))
  return id
})

const ostChangeRequest = createSlice({
  name: 'ost_change_request',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedOstChangeRequest: null
  },
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(getAllOSTChangeRequest.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.selectedOstChangeRequest = null
      })
      .addCase(getOstChangeRequestById.fulfilled, (state, action) => {
        state.selectedOstChangeRequest = action.payload?.data ?? action.payload
      })
      .addCase(getOstChangeRequestsByVehicleId.fulfilled, (state, action) => {
        state.data = action.payload?.data ?? action.payload
        state.total = state.data.length
      })

      .addCase(updateOstChangeRequest.fulfilled, (state, action) => {
        if (!action.payload?.id) {
          console.log('Update could not complete')
          console.log(action.payload)
          return
        }
        const { id } = action.payload
        const ownership = state.data.filter((ownership) => ownership.id !== id)
        state.data = [...ownership, action.payload]
      })
  }
})

export default ostChangeRequest.reducer
